<template>
  <div id="operation-record-dialog">
    <ipub-model title="Operation Record Details"
                width="800px"
                :visable="isVisable"
                @cancel="cancel"
                :showFooter="false">
      <div class="ipubw-p1 mar-b-16">{{inputData.info}}</div>
      <div class="ipub-p2"
           v-html="detail"></div>
    </ipub-model>
  </div>
</template>

<script>
import operation from '@/api/operation'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  watch: {
    isVisable (val) {
      if (val) {
        this.getQuery()
      } else {
        this.detail = ''
      }
    }
  },
  data () {
    return {
      detail: ''
    }
  },
  methods: {
    async getQuery () {
      this.detail = await operation.query(this.inputData.id)
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
